import { B2CSubscriptionStatus } from '@src/global/types/types';

export type B2CSubscriptionEdge = {
  node?: {
    bpStatus?: { code?: string };
    hiConsistsOf?: Array<{ biiSalable?: { maId?: string } }>;
    hiPartOf?: B2CSubscriptionPartOf[];
  };
};

type B2CSubscriptionPartOf = {
  wSiteId?: string;
  hiPartOf?: B2CSubscriptionPartOf[];
};

const getSubscriptionSiteId = (
  hiPartOf: B2CSubscriptionPartOf[] | null | undefined
): string | undefined => {
  for (const partOfNode of hiPartOf ?? []) {
    if (partOfNode?.wSiteId) {
      return partOfNode.wSiteId;
    }

    const nestedSiteId = getSubscriptionSiteId(partOfNode?.hiPartOf);
    if (nestedSiteId) {
      return nestedSiteId;
    }
  }

  return undefined;
};

export const hasActiveB2CSubscription = (
  subscriptions: B2CSubscriptionEdge[] | null | undefined,
  cartMaIds: string[],
  currentSiteId?: string
): boolean => {
  const activeStatuses = new Set([
    B2CSubscriptionStatus.CREATED,
    B2CSubscriptionStatus.ACTIVE,
    B2CSubscriptionStatus.PENDING_RENEWAL,
    B2CSubscriptionStatus.PENDING_CANCELLATION,
    B2CSubscriptionStatus.PAYMENT_FAILED,
  ]);

  return (subscriptions ?? []).some((edge) => {
    const status = edge?.node?.bpStatus?.code;
    if (!status || !activeStatuses.has(status as B2CSubscriptionStatus)) {
      return false;
    }

    const hasMatchingProduct = (edge?.node?.hiConsistsOf ?? []).some(
      ({ biiSalable }) => {
        return Boolean(biiSalable?.maId) && cartMaIds.includes(biiSalable.maId);
      }
    );

    if (hasMatchingProduct) {
      return true;
    }

    const hasProductReference = (edge?.node?.hiConsistsOf ?? []).some(
      ({ biiSalable }) => Boolean(biiSalable?.maId)
    );

    if (!currentSiteId || hasProductReference) {
      return false;
    }

    const subscriptionSiteId = getSubscriptionSiteId(edge?.node?.hiPartOf);
    return subscriptionSiteId === currentSiteId;
  });
};
